import { Col, Form, Row, Select } from "antd"
import React from "react"
import FloatingLabelInput from "../../FloatingLabelInput/FloatingLabelInput"
import { uniqBy } from "lodash"
import countriesArray from "config/countryArr"
import AdressAutoFinder from "../../AdressAutoFinder/AdressAutoFinder"
import AddressInput from "./AddressFinder"

const { Option } = Select

function Step2({ form, formData, setFormData }) {
  const { getFieldDecorator } = form

  const handleInputChange = (field) => (e) => {
    e.persist()
    setFormData((prevState) => ({
      ...prevState,
      [field]: e.target.value,
    }))
  }

  const allNazione = uniqBy(countriesArray, "nazione")

  const nazioneList = []
  if (allNazione && allNazione.length > 0) {
    for (let i = 0; i < allNazione.length; i++) {
      nazioneList.push(
        <Option key={allNazione[i].nazione} value={allNazione[i].nazione}>
          {allNazione[i].nazione}
        </Option>
      )
    }
  }

  return (
    <>
      <Form.Item hasFeedback>
        {getFieldDecorator("aPiva", {
          initialValue: formData.aPiva,
          rules:
            formData.nazione === "ITALIA"
              ? [
                  {
                    required: true,
                    message: "Inserire P.Iva",
                    whitespace: true,
                  },
                  {
                    pattern: /^\d{11}$/,
                    message: "La P.Iva deve avere esattamente 11 numeri!",
                  },
                ]
              : [],
        })(
          <FloatingLabelInput label="P.Iva" onChange={handleInputChange("aPiva")} />
        )}
      </Form.Item>

      <Form.Item hasFeedback>
        {getFieldDecorator("aRagSoc", {
          initialValue: formData.aRagSoc,
          rules: [{ required: true, message: "Inserire nome!", whitespace: true }],
        })(
          <FloatingLabelInput
            label="Ragione sociale"
            onChange={(e) => {
              handleInputChange("aRagSoc")(e)
            }}
          />
        )}
      </Form.Item>
      <Form.Item hasFeedback>
        {getFieldDecorator("address", {
          initialValue: formData.address,
          rules: [
            {
              required: true,
              message: "Inserisci il tuo indirizzo!",
              whitespace: true,
            },
          ],
        })(
          <FloatingLabelInput
            label="Sede legale"
            onChange={(e) => {
              handleInputChange("address")(e)
            }}
          />
        )}
      </Form.Item>

      <Form.Item hasFeedback>
        {getFieldDecorator("aInsegna", {
          initialValue: formData.aInsegna,
          rules: [{ required: true, message: "Inserire cognome!" }],
        })(
          <FloatingLabelInput
            label="Insegna"
            onChange={(e) => {
              handleInputChange("aInsegna")(e)
            }}
          />
        )}
      </Form.Item>

      <Form.Item hasFeedback>
        {getFieldDecorator("aAdress", {
          initialValue: formData.aAdress,
          rules: [
            {
              required: true,
              message: "Inserire la sede operativa",
              whitespace: true,
            },
          ],
        })(
          <AddressInput form={form} formData={formData} setFormData={setFormData} />
        )}
      </Form.Item>
      <Form.Item>
        {getFieldDecorator("cordinate", {
          initialValue: formData.cordinateReq,
          rules: [
            {
              required: false,
              whitespace: true,
              message: "Inserisci le cordinate!",
            },
          ],
        })(
          <FloatingLabelInput
            label="Cordinate punto vendita"
            onChange={(e) => {
              handleInputChange("cordinateReq")(e)
            }}
          />
        )}
      </Form.Item>

      {formData?.nazione === "ITALIA" ? (
        <AdressAutoFinder
          titles={{
            nazione: "Nazione punto vendita",
            province: "Provincia punto vendita",
            comune: "Comune punto vendita",
            cap: "Cap punto vendita",
          }}
          capFormKey="aCap"
          form={form}
          nazione={formData.nazioneDiResidenca}
          province={formData.residence_province}
          comune={formData.residence_city}
          setNazione={(nazione) =>
            setFormData((prev) => ({ ...prev, nazioneDiResidenca: nazione }))
          }
          setProvince={(province) =>
            setFormData((prev) => ({ ...prev, residence_province: province }))
          }
          setComune={(comune) =>
            setFormData((prev) => ({ ...prev, residence_city: comune }))
          }
        />
      ) : (
        <>
          <Form.Item hasFeedback>
            {getFieldDecorator("cap", {
              initialValue: formData.aCap,
            })(
              <FloatingLabelInput
                label="Cap punto vendita"
                onChange={handleInputChange("aCap")}
              />
            )}
          </Form.Item>

          <Form.Item hasFeedback>
            {getFieldDecorator("comune", {
              initialValue: formData.residence_city,
            })(
              <FloatingLabelInput
                label="Comune punto vendita"
                onChange={handleInputChange("residence_city")}
              />
            )}
          </Form.Item>

          <Form.Item hasFeedback>
            {getFieldDecorator("provincia", {
              initialValue: formData.residence_province,
            })(
              <FloatingLabelInput
                label="Provincia punto vendita"
                onChange={handleInputChange("residence_province")}
              />
            )}
          </Form.Item>

          <Form.Item hasFeedback style={{ marginBottom: "16px" }}>
            <Select
              showSearch
              placeholder="Seleziona nazione"
              optionFilterProp="children"
              value={formData.nazioneDiResidenca || undefined}
              onChange={(e) => {
                setFormData((prevState) => ({
                  ...prevState,
                  nazioneDiResidenca: e,
                }))
              }}
              allowClear
            >
              {nazioneList}
            </Select>
          </Form.Item>

          {/* <Form.Item hasFeedback style={{ marginBottom: "16px" }}>
            {formData.nazioneDiResidenca === "" && (
              <Select
                placeholder="Nazione punto vendita"
                defaultValue={formData.nazioneDiResidenca}
                onChange={(e) => {
                  setFormData((prevState) => ({
                    ...prevState,
                    nazioneDiResidenca: e,
                  }))
                }}
              >
                {nazioneList}
              </Select>
            )}
            {formData.nazioneDiResidenca !== "" && (
              <Select
                placeholder="Nazione punto vendita"
                value={formData.nazioneDiResidenca}
                onChange={(e) => {
                  setFormData((prevState) => ({
                    ...prevState,
                    nazioneDiResidenca: e,
                  }))
                }}
              >
                {nazioneList}
              </Select>
            )}
          </Form.Item> */}
        </>
      )}

      <Form.Item hasFeedback>
        {getFieldDecorator("aPhone", {
          initialValue: formData.aPhone,
          rules: [{ required: true, message: "Inserire numero di telefono!" }],
        })(
          <FloatingLabelInput
            label="Telefono punto vendita"
            onChange={(e) => {
              handleInputChange("aPhone")(e)
            }}
          />
        )}
      </Form.Item>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item hasFeedback>
            {getFieldDecorator("pagmens", {
              initialValue: formData.pagmens,
              rules: [
                {
                  required: true,
                  message: "Inserire Pagamento Mensile",
                  whitespace: true,
                },
              ],
            })(
              <FloatingLabelInput
                type="number"
                label="Pagamento mensile"
                onChange={handleInputChange("pagmens")}
              />
            )}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item hasFeedback>
            {getFieldDecorator("tipo_di_mensile", {
              initialValue: formData.tipo_di_mensile,
              rules: [
                {
                  required: true,
                  whitespace: true,
                },
              ],
            })(
              <Select
                placeholder="Tipo di Pagamento Mensile"
                onChange={(e) => {
                  setFormData((prevState) => ({
                    ...prevState,
                    tipo_di_mensile: e,
                  }))
                }}
              >
                <Option value="annually">Annuale</Option>
                <Option value="monthly">Mensile</Option>
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}

export default Step2
